import { AxiosResponse } from "axios";
import instance from "../common/http.common";

const _rootUrl: string = process.env.REACT_APP_API_ROOT_URL ?? "";
const _baseUrl: string = `${_rootUrl}/FailedPaylocityRequests`;

export const FailedPaylocityRequestsService = {
  GetFailedRequests: async (): Promise<AxiosResponse<any>> => {
    return await instance.get(_baseUrl);
  },
  ResolveFailedRequest: async (id: number, resolvedNote: string, resolvedUserId: number): Promise<AxiosResponse<any>> => {
    let res = await instance.put(_baseUrl, { id, resolvedNote, resolvedUserId });
    return res.data;
  },
};